module.exports = __webpack_public_path__ + "media/images/ico_free-70c0fe0d0f9210e6e5bd4df17c2ce3b6.svg";